import { getLastWord } from '@/common/util/util.js';

export function lastWordTag(text) {
    const lastWord = getLastWord(text);

    if (lastWord.startsWith('#'))
        return lastWord.slice(1);

    return null;
}
